export function tileSignatureFromSides(sides) {
  const counts = new Map();
  for (const t of sides) counts.set(t, (counts.get(t) || 0) + 1);
  const entries = Array.from(counts.entries());
  if (entries.length <= 1) return `${entries[0]?.[0] ?? "unknown"}_6`;
  // sort by count desc, then name asc for determinism
  entries.sort((a, b) => (b[1] - a[1]) || (a[0] < b[0] ? -1 : 1));
  const [major, majorCount] = entries[0];
  const [minor, minorCount] = entries[1];
  return `${major}_${majorCount}_${minor}_${minorCount}`;
}
